import * as React from 'react'

import { cn } from '@/legacy-src/lib/utils'

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'file:text-foreground flex w-full rounded-lg border-2 border-solid border-input bg-white p-4 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring enabled:read-only:cursor-default enabled:read-only:bg-sand-100 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-peach-800 aria-invalid:ring-peach-800',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
